export class GridFilterModel {
  public textFilter: string | null | undefined;

  public constructor(textFilter: string | null | undefined) {
    this.textFilter = textFilter;
  }
}
